import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointGridSpecialAttentionTemplate]',
  standalone: true
})
export class GridSpecialAttentionTemplateDirective {

  constructor() { }

}
